import { ActionIcon, Box, TextInput, Tooltip } from "@mantine/core";
import { useState } from "react";

import { IconSearch, IconX } from "@/components/icons";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type ListTableSearchInputProps = {
  defaultValue?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  resetTooltip?: string;
  updateOnChange?: boolean;
  value?: string;
} & MantineStyleProps;

export const ListTableSearchInput: FC<ListTableSearchInputProps> = ({
  defaultValue = "",
  disabled = false,
  onChange,
  placeholder,
  resetTooltip,
  updateOnChange = false,
  value,
  ...props
}) => {
  const [uncontrolledQuery, setUncontrolledQuery] = useState(defaultValue);
  const isControlled = value !== undefined;
  const query = isControlled ? value : uncontrolledQuery;

  function updateQuery(nextValue: string) {
    if (!isControlled) {
      setUncontrolledQuery(nextValue);
    }
    onChange(nextValue);
  }

  return (
    <TextInput
      disabled={disabled}
      flex={1}
      {...props}
      leftSection={<IconSearch size={24} />}
      onChange={(evt) => {
        const nextValue = evt.currentTarget.value;
        if (!isControlled) {
          setUncontrolledQuery(nextValue);
        }
        if (updateOnChange) {
          onChange(nextValue);
        }
      }}
      onKeyDown={(evt) => {
        if (evt.key === "Enter") {
          updateQuery(query);
        }
      }}
      placeholder={placeholder}
      rightSection={
        query && (
          <Tooltip
            label={resetTooltip}
            disabled={resetTooltip === undefined}
            events={{ hover: true, focus: true, touch: true }}
          >
            <Box component="span" pos="relative" top={0.5} display="inline-block">
              <ActionIcon
                variant="danger"
                onClick={() => {
                  updateQuery("");
                }}
              >
                <IconX size={24} />
              </ActionIcon>
            </Box>
          </Tooltip>
        )
      }
      value={query}
    />
  );
};
